<template>
  <div class="content_menu">
    <div class="left" style="width:178px;">
      <TheFoodMenu />
    </div>

    <div class="right" style="width:705px; height:468px;">
      <div class="left" style="width:500px;">
        <div class="menu_burger">
          <router-link to="/menu/burgers">
            <img src="/assets/images/clr.png" style="width:106px; height:398px;">
          </router-link>
        </div>

        <div class="left" style="margin:12px 0 0 -2px;">
          <a href="/menu/burgers">
            <img src="/assets/images/menu_img/menu_main_burgerimg.png">
          </a>
        </div>

        <div class="menu_shake">
          <a href="/menu/shakes">
            <img src="/assets/images/clr.png" style="width:85px; height:252px;">
          </a>
        </div>

        <div class="menu_salad">
          <a href="/menu/salads">
            <img src="/assets/images/clr.png" style="width:354px; height:139px;">
          </a>
        </div>
      </div>

      <div class="left" style="margin:20px 0 0 13px; width:172px; height:246px; overflow:hidden;">
        <img src="/assets/images/changing_menuPics.png" style="float:left;" id="menu_corner">
      </div>

      <div class="left" style="margin:20px 0 0 6px; width:172px;">
        <a href="/menu/salads">
          <img src="/assets/images/menu_img/menu_salad.png" style="float:left;">
        </a>
      </div>
    </div>

    <br clear="all" />

    <div class="left" style="width:470px;">
      <div class="left" style="margin:-16px 0 0 12px;">
        <img src="/assets/images/menu_graphic_people.png" />
      </div>
    </div>

    <div class="right" style="width:405px; margin:-20px 30px 0 0;">
      <p style="padding-bottom:10px;">
        At Jeffrey&#8217;s we believe that freshness makes a difference you can taste.
        We pride ourselves on serving traditional American dishes in the best possible way.
        From our thick creamy shakes to our out-of-this-world BLT, Jeffrey’s pays attention
        to the details.
      </p>

      <a
          class="togo-menu-button"
          href="/assets/images/jeffreys_hamburgers_togo.pdf"
          alt="Jeffrey's Hamburgers to go menu"
          target="jeffreys_togo_menu"
      >
        Download Our Takeout Menu
      </a>
    </div>
  </div>
</template>

<script>
import TheFoodMenu from '@/components/TheFoodMenu.vue';

export default {
  name: 'Menu',
  components: {
    TheFoodMenu,
  },
};
</script>
